import React, { FC } from "react";
import { IWizardStepContent } from "../../../../../wizard/types";
import Template from "../../templates/step3/Template";

const Content: FC<IWizardStepContent> = ({ stepName, ...formData }) => (
  <Template stepName={stepName} formData={formData} />
);

export default Content;
